import React from 'react'
import SearchBar from './SearchBar'
import Add from './Add'
import Liste from './Liste'
import { Box } from '@mui/material'
import Title from '../components/Title'


export default function Service() {
    return (
        <Box sx={{ flexGrow: 1, width: "100%" }}>

            <Box style={{ display: "flex", justifyContent: "space-between" }} >

                {/*---------------- debut titre --------------*/}
                <Title
                    intitule='Service'
                />
                {/*---------------- fin titre --------------*/}


                {/*---------------- debut add --------------*/}
                <Box sx={{ width: "50%" }}>
                    <SearchBar />
                </Box>
                {/*---------------- fin add --------------*/}


                {/*---------------debut SearchBar --------- */}
                <Box>
                    <Add />
                </Box>
                {/* ------------------fin  SearchBar ------------*/}
            </Box>

            {/*---------------- debut Liste -----------------*/}
            <Liste />
            {/*--------------- fin Liste ------------------ */}
        </Box>
    )
}
